import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/offcanvas';
import 'bootstrap/js/src/modal';
// import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/collapse';
import './swiper';
import GLightbox from 'glightbox';

const lightbox = GLightbox({
    loop: true,
    selector: '.wp-block-gallery a'
});


const allVideoPopups = document.querySelectorAll('.wp-video-popup__modal');
if (allVideoPopups) {
    allVideoPopups.forEach(popup => {
        popup.addEventListener('show.bs.modal', () => {
            const videoUrl = popup.dataset.videoUrl;
            const videoFrame = popup.querySelector('iframe');
            videoFrame.setAttribute('src', videoUrl)
        })

        popup.addEventListener('hide.bs.modal', () => {
            const videoFrame = popup.querySelector('iframe');
            videoFrame.setAttribute('src', '')
        })
    })
}